<template>
  <div class="split-container">
    <template v-if="(tableStyleField.isInitTable === false) && !isGetListData">
      <initPage width="100%" :config="initConfig" />
    </template>
    <template v-else>
      <template v-if="splitInfo.bindingFunction === 'write-table'">
        <template v-if="splitInfo.splitInfo.isBatchAddTag">
          <screenSelect :info="splitInfo.splitInfo.tagInfo" />
        </template>
        <oaExamineInput
          v-else
          :isDoorAdd="true"
          :approvalId="appId"
          :coverVal="coverVal"
          v-model:isAi="isAi"
          :themeColor="themeColor"
          :isSplitScreen="true"
          :allAddInfo="allAddInfo"
          @upIsAi="upIsAi"
          @upIsPcwidth="upIsPcwidth"
          @upIsPcHeight="upIsPcHeight"
          @getfaceAr="getfaceAr"
          @change-iagreepargam="changeIagreepargam"
          :modify="iId === 13 || iId === 14 ? modify : ''"
          :person="iId === 14 ? 0 : 1"
          @refFlowshow="refFlowshow"
          @inputClose="inputClose"
          @retRefresh="retRefresh"
          @doorUp="doorUp"
          type="1"
          ref="AuditOpenInput"
        ></oaExamineInput>
      </template>
      <template v-else-if="['outside', 'custom-scene'].indexOf(splitInfo.bindingFunction) !== -1">
        <template v-if="splitInfo.bindingFunction === 'custom-scene' && isComp">
          <component style="width: 100%; height: 100%;" v-if="isComp" :is="isComp" :key="refreshKey" :customDeskInfo="customDeskInfo" :id="customDeskInfo.reportId" :isAppenTitle="false" />
        </template>
        <iframe
          v-else
          allow="clipboard-read; clipboard-write"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads allow-modals"
          :src="iframeUrl"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </template>
      <template v-else-if="splitInfo.bindingFunction === 'inside'">
        <template v-if="isAppenInside">
          <oaExamineInput
            v-if="insideInfo.isAdd"
            :isDoorAdd="true"
            :approvalId="insideInfo.id"
            :coverVal="insideInfo.coverVal"
            v-model:isAi="isAi"
            :themeColor="themeColor"
            :isSplitScreen="true"
            @upIsAi="upIsAi"
            @upIsPcwidth="upIsPcwidth"
            @upIsPcHeight="upIsPcHeight"
            @getfaceAr="getfaceAr"
            @change-iagreepargam="changeIagreepargam"
            :modify="insideInfo.iId === 13 || insideInfo.iId === 14 ? insideInfo.modify : ''"
            :person="insideInfo.iId === 14 ? 0 : 1"
            @refFlowshow="refFlowshow"
            @inputClose="inputClose"
            @doorUp="doorUp"
            type="1"
            ref="AuditOpenInput"
          ></oaExamineInput>
          <oaExamineAudit v-else-if="insideInfo.isRead" :iId="insideInfo.iId" ref="AuditOpenChild" class="oaExamineAudit" :open="true"></oaExamineAudit>
          <template v-else-if="insideInfo.isIframe && isComp">
            <component style="width: 100%; height: 100%;" v-if="isComp" :is="isComp" :customDeskInfo="customDeskInfo" :id="customDeskInfo.reportId" :isAppenTitle="false" />
          </template>
        </template>
      </template>
      <template v-else-if="['app-detail', 'app-comment'].includes(splitInfo.bindingFunction)">
        <oaExamineAudit :viewDetailFun="splitInfo.bindingFunction" :websiteSwitch="false" ref="AuditOpenChild" class="oaExamineAudit" :open="true"></oaExamineAudit>
      </template>
    </template>
  </div>
</template>

<script>
import oaExamineInput from '@/components/clientSide/oaExamineInput.vue'
import oaExamineAudit from '@/components/clientSide/oaExamineAudit.vue'
import { getAddCoverval, getParamsLists  } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getappperAuthority } from "@/port/schoolInstrument/appConfig";
import { axiosBase } from '@/api/api'
import { stringify, parse } from 'qs'
import organization from '@/components/admins/organization/organization'
import organizationRole from '@/components/admins/organization/organizationRole'
import organizationUser from '@/components/admins/organization/organizationUser'
import operationLog from '@/components/admins/organization/operationLog'
import customInstrument from '@/components/schoolInstrument/customInstrument.vue'
import instrument from '@/components/clientSide/instrument/instrument'
import application from '@/components/clientSide/applicationRouting'
import reportView from '@/components/reportView/index'
import screenSelect from './screenSelect.vue'
import initPage from "@/components/schoolInstrument/component/mutual/component/form/initPage.vue";
export default {
  // 组件名称
  name: 'splitScreen',
  // 组件参数 接收来自父组件的数据
  props: {
    appId: {
      type: [String, Number]
    },
    iId: {
      type: [String, Number],
    },
    themeColor: {
      type: String,
      default: '#4e86ff'
    },
    datatype: [String, Number],
    splitInfo: {
      type: Object,
      default: ()=>({}) 
    },
    screenRef: {
      type: Array,
      default: ()=>([])
    },
    // 当前选择的组织id和name 
    currentOrg: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      default: () => ({})
    },
    detailInfo: {
      type: Object,
      default: ()=>({})
    },
    customData: {
      type: Array,
      default: ()=>([])
    },
    customDeskId: {
      type: [Number, String],
      default: 0,
    },
    isGetListData: {
      type: Boolean,
      default: false
    },
    tableStyleField: {
      type: Object,
      default: ()=>({})
    },
    initConfig: {
      type: Object,
      default: ()=>({})
    },
  },
  // 局部注册的组件
  components: {
    oaExamineInput,
    oaExamineAudit,
    screenSelect,
    initPage
  },
  // 组件状态值
  data() {
    return {
      isdiaVisible:false,
      // 是否显示流程
      flowshow: 2,
      isAi: 0,
      isfaceAr: 0, //0 未配置人脸识别 1 拍摄模式 2 AR模式
      iAgreePargam: {},
      showModal: false, //是否显示遮罩层
      coverVal: {},
      iframeUrl: '',
      insideInfo: {
        url: '',
        id: '',
        coverVal: {},
        modify: {},
        iId: -1,
        isAdd: false,
        isRead: false,
        isIframe: false
      },
      spaceid: this.$route.query.spaceid,
      upaceid: this.$route.query.upaceid,
      // 站内应用是否显示
      isAppenInside: false,
      allAddInfo: {
        isBatchAdd: false,
        filedName: ''
      },
      customDeskInfo: {},
      refreshKey: new Date().getTime().toString().slice(-6)
    }
  },
  mounted() {
    // this.init()
  },
  inject: {
    homeId: {
      default: null
    }
  },
  computed: {
    isComp() {
      const obj = {
        '/organization': organization,
        '/organizationRole': organizationRole,
        '/organizationUser': organizationUser,
        '/operationLog': operationLog,
      }
      let path = ''
      if (this.splitInfo.bindingFunction === 'custom-scene') {
        path = this.iframeUrl
      } else {
        path = this.insideInfo.url
      }
      if (path.includes('userId') && path.includes('operationLog')) {
        path = '/operationLog'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isSystemPersonal = true
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.isSystemPersonal = false
      }
      
      let flag = obj[path]
      if (!flag) {
        // 由于 需要把场景和仪表盘和报表和表单变成组件模式 这边再去判断
        let queryStr = ''
        try {
          queryStr = decodeURIComponent(path).split('?')[1]
        } catch (error) {
          queryStr = path.split('?')[1]
        }
        const query = parse(queryStr)
        if (path.includes('/customInstrument')) {
          flag = customInstrument
        } else if (path.includes('/clientSide/instrument/instrument')) {
          // 仪表盘
          let search = query.search
          if (search && JSON.parse(search)) {
            search = JSON.parse(search)
            for (const key in search) {
              const ele = search[key]
              if (typeof ele === 'string') {
                search[key] = ele.split(',')
              } else {
                search[key] = ele
              }
            }
            query.search = JSON.stringify(search)
          }
          flag = instrument
        } else if (path.includes('/clientSide/reportView')) {
          // 报表
          flag = reportView
        } else if (path.includes('/clientSide/application')) {
          // 应用
          flag = application
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.customDeskInfo = query
      }
      if (flag) {
        return flag
      } else {
        return false
      }
    },
  },
  // 组件方法
  methods: {
    async init() {
      const { bindingFunction, customScene, insideInfo = {}, splitInfo = {}, newlyAdded = [], newlyAddCustomed = [] } = this.splitInfo
      const { batchAddControl, isBatchAdd, } = splitInfo
      let customData = []
      if (this.customData.length > 0) {
        customData = this.customData
      } else if (this.homeId) {
        // 当前页面的自定义参数
        customData = this.$store.state.doorCustomDataObj[this.homeId()] || []
      } else if (this.customDeskId || this.customDeskInfo.customDeskId) {
        const customDeskId = this.customDeskId || this.customDeskInfo.customDeskId
        customData = this.$store.state.doorCustomDataObj[customDeskId] || []
      } else {
        customData = this.$store.state.doorCustomData
      }
      if (bindingFunction === 'write-table') {
        const obj = getAddCoverval({
          newlyAdded,
          newlyAddCustomed,
          screens: this.screenRef,
          currentOrg: this.currentOrg,
          customData
        })
        if (Object.keys(obj).length !== 0) {
          this.coverVal = obj
        }
        if (isBatchAdd) {
          const ele = newlyAdded.find(c => c.screenId == batchAddControl)
          const allAddInfo = {
            isBatchAdd,
            filedName: ''
          }
          if (ele) {
            allAddInfo.filedName = ele.filedName
            this.allAddInfo = allAddInfo
          }
        }
        return obj
      } else if (bindingFunction === 'custom-scene') {
        const url = '/customInstrument'
        const query = { name: customScene.params, customDeskId: customScene.id }
        if (customScene.paramsList && customScene.paramsList.length > 0) {
          const paramsList = JSON.parse(JSON.stringify(customScene.paramsList))
          // 页面入参
          if (paramsList && paramsList.length > 0) {
            const obj = {
              paramsList: paramsList,
              customData,
              currentOrg: this.currentOrg,
              screen: this.screenRef,
            }
            const paramsLists = getParamsLists(obj)
            if (paramsLists.length > 0) {
              query.paramsList = paramsLists
            }
          }
        }
        this.iframeUrl = `${url}?${stringify(query)}`
        this.refreshKey = new Date().getTime().toString().slice(-6)
      } else if (bindingFunction === 'outside') {
        this.iframeUrl = insideInfo.url
      } else if (['app-detail', 'app-comment'].includes(bindingFunction)) {
        this.openDetail(this.detailInfo)
      } else if (bindingFunction === 'inside') {
        this.isAppenInside = false
        const { appid, datatype, appIid, appName } = insideInfo
        const str = await this.getApper({ appid, datatype })
        if (!str) return
        // 仪表盘
        const search = getAddCoverval({
          newlyAdded: this.splitInfo.newlyAdded,
          newlyAddCustomed: this.splitInfo.newlyAddCustomed,
          screens: this.screenRef,
          currentOrg: this.currentOrg,
          isDashboard: datatype === 5,
          customData
        })
        const obj = {
          11: true,
          13: true,
          14: true,
          15: true,
          16: true
        }
        if (obj[appIid]) {
          // 不是Iframe
          if (appIid === 11 || appIid === 13 || appIid === 14) {
            
            this.insideInfo.isAdd = true
            if (appIid === 11) {
              this.insideInfo.id = appid
              this.insideInfo.iId = appIid
              this.insideInfo.coverVal = search
            } else {
              const info = await this.getDetailInfo(insideInfo, search)
              if (!info) return
              info.modifyId = info.approvingId
              this.insideInfo.modify = info
              this.insideInfo.id = appid
              this.insideInfo.iId = appIid
            }
          } else {
            this.insideInfo.isRead = true
            this.isAppenInside = true
            const info = await this.getDetailInfo(insideInfo, search)
            if (!info) return
            info.modifyId = info.approvingId
            if (!info.approvalId) {
              info.approvalId = appid
              info.approving = {
                approvingId: info.approvingId
              }
            }
            if (info.userApprovingId) info.userapprovingId = info.userApprovingId
            this.$refs.AuditOpenChild.AuditOpenList(info)
          }
        } else {
          this.insideInfo.isIframe = true
          if (datatype !== 1) {
            // 非表单
            this.insideInfo.url = await this.getOpenUrl(datatype, search, appid)
          } else {
            const obs = {
                approvalId: appid,
                iId: appIid,
                source: 'user',
                name: appName,
                navShow: false,
                search: search,
            }
            if (appIid === 8) {
              // 提交统计
              this.insideInfo.url = `/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?${stringify(obs)}`
            } else {
              const keys = {
                2: 'pageId',
                3: 'pageId',
                4: 'pageId',
                5: 'pageId',
                1: 'pageId',
                7: 'dataId',
                6: 'dataId',
                9: 'funId',
              }
              obs[keys[appIid]] = appIid
              this.insideInfo.url = `/clientSide/application?${stringify(obs)}`
            }
          }
        }
        this.isAppenInside = true
      }
    },
    retRefresh() {
      this.$emit('updateTable')
    },
    openDetail(row) {
      if (!row) return
      if (Object.keys(row).length === 0) return
      let param = {
        approving: {
          approvingId: row.approvingId,
        },
        userapprovingId: row.userApprovingId,
        approvalId: this.appId,
      }
      this.$refs.AuditOpenChild.AuditOpenList(param, 1)
    },
    async getDetailInfo (item, query) {
      // 首先获取 权限
      const params = {
        approvalId: item.appid,
        approving: {},
      }
      const _power = {
        approvalId: item.appid,
        curpage: 0,
        pagesize: 0
      }
      if (this.spaceid) {
        _power.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
      } else if (this.upaceid) {
        _power.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      const { data, code, msg } = await axiosBase(_power, '/openapi/getreportformlist')
      if (code === 0) {
        let power = {}
        if (item.appIid === 15 || item.appIid === 13) {
          power = data.find(item=>item.userId)
        }else {
          power = data.find(item=>!item.userId)
        }
        const _list = {
          type: 0,
          curpage: 1,
          pagesize: 20,
          cateId: -1,
          key: '',
          querys: {},
          query: query || {},
          approvalId: item.appid,
          reportFormId: power.reportFormId
        }
        // 从空间进入，需要传空间id
        if(this.spaceid){
          _list.spaceid = this.spaceid;
        } else if(this.upaceid){
          _list.upaceid = this.upaceid;
        }
        const api = item.appIid === 15 || item.appIid === 13 ? '/api/getuserfielddatalist' : '/api/getfielddatalist'
        if (item.appIid === 19 || item.appIid === 20) {
          _list.datanum = 1
        }
        const { data: list, code: code1, msg: msg1 } = await axiosBase(_list, api)
        if (code1 === 0) {
          const ids = [13, 14, 15, 16, 19, 20]
          if (ids.indexOf(item.appIid) !== -1) {
            if (list.length === 0) this.$message.warning('暂无可查看数据！')
            return list[0]
          }
          const list1 = list[0]
          if (list1) {
            params.approving.approvingId = list1.approvingId
            params.userapprovingId = list1.userApprovingId
          }
        } else {
          this.$message.error(msg1)
        }
      } else {
        this.$message.error(msg)
      }
      return params
    },
    async getOpenUrl(type, search, id) {
      const urlObj = {
        5: `/clientSide/instrument/instrument?dataReportId=${id}&search=${JSON.stringify(search)}&showSearch=false`,
        7: `/clientSide/reportView/?reportId=${id}`
      }
      urlObj[2] = await this.getApper({datatype: type, appid: id})
      return urlObj[type]
    },
    async getApper(item) {
      const obj = {
          appid: item.appid,
          datatype: item.datatype
      }
      // 从空间进入，需要传空间id
      if (this.spaceid) {
          let spaceId = typeof (this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
          obj.spaceid = spaceId;
      } else if (this.upaceid) {
          let upaceId = typeof (this.$route.query.upaceId) !== 'undefined' ? this.$route.query.upaceId : localStorage.getItem('upaceId')
          obj.upaceid = upaceId;
      }
      if (this.$route.query.spaceid) {
          obj.spaceid = this.$route.query.spaceid
      } else if (this.$route.query.upaceid || localStorage.getItem('upaceid')) {
          obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      const res = await getappperAuthority(obj).catch(err => { console.log(err) })
      if (item.datatype !== 2) {
          return res
      }
      if (res.code === 0 && res.data.per) {
          return res.data.pcUrl
      } else {
          this.$message.warning(res.msg || '暂无权限!')
      }
      return false
  },
    changeIagreepargam(val) {
      this.iAgreePargam = val
    },
    upIsAi (val) {
      this.isAi = val
    },
    upIsPcwidth(val) {
      this.pdwidth = val
    },
    upIsPcHeight(val){
      this.pdheight = val
    },
    // 返回给仪表盘刷新的
    doorUp () {
      this.$emit('doorUp')
    },
    // 关闭input
    inputClose () {
      this.$refs.AuditOpenInput.closeSetTime()
      this.$refs.AuditOpenInput.getsubmitformlist()
      this.$emit('updateTable')
    },
    refFlowshow (res) { // 子集
      this.flowshow = res
    },
    onFlowshow () {
      this.flowshow = this.flowshow ? 0 : 1
      this.$refs.AuditOpenInput.flowshow = this.flowshow
    },
    faceArChange(){
      this.isfaceAr = this.isfaceAr === 1 ? 2 : 1
      this.$refs.AuditOpenInput.faceArChange(this.isfaceAr)
    },
    // 获取人脸识别是否打开
    getfaceAr(val){
      this.isfaceAr = val
      if(this.isfaceAr !== 0){
        this.fullscreen = true
      } else{
        this.fullscreen = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.split-container {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translate(0, 0);
  ::v-deep .oaExamineInput {
    height: 100%;
    .wisdomSubmit {
      overflow: hidden;
      width: 100% !important;
      height: 100% !important;
    }
  }
  ::v-deep .oaExamineAudit {
    height: 100%;
    width: 100%;
    .cur-detail {
      height: 100%;
      .oaExamineRight {
        .ctoArray-class {
          height: 100%;
        }
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
        .el-scrollbar__view {
          padding-left: 0 !important;
        }
      }
      .el-form {
        height: 100%;
        overflow-x: hidden;
        .cto-list {
          background-color: #fff;
          width: 100%;
          margin: 0;
          padding-left: 40px;
        }
        .widget-one-layer {
          height: 100%;
          width: 100%;
          box-sizing: border-box;
          padding-left: 0;
          padding-right: 0;
          margin-left: 0;
          .widget-one-layer-row {
            height: 100%;
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
        }
      }
    }
  }
  
}
</style>
